// extracted by mini-css-extract-plugin
var _1 = "confirmHeader-ba2C";
var _2 = "label-Yn8Y";
var _3 = "note-DL7Q";
var _4 = "pair-ei0Z";
var _5 = "splitConfirmContentView-UfGF";
export { _1 as "confirmHeader", _2 as "label", _3 as "note", _4 as "pair", _5 as "splitConfirmContentView" }
